// Unique light tint per category. Thick black border applied where used.
const MAP = {
  "All": "#FFFFFF",
  "Administrative and Accounting (A)": "#FDE2E4",
  "Civil Forms (CV)": "#E0F2FE",
  "Civil Revocation Forms (CVR)": "#FEF3C7",
  "Court of Appeals (COA)": "#DCFCE7",
  "Criminal Forms (CR)": "#FEE2E2",
  "Dispute Resolution Commission (DRC)": "#EDE9FE",
  "Estate (E)": "#FFF1E6",
  "Financial Services (FS)": "#CFFAFE",
  "General Forms (G)": "#F3E8FF",
  "Governor's (GOV)": "#FCE7F3",
  "Juvenile (J)": "#ECFCCB",
  "Miscellaneous Forms": "#E7E5E4",
  "Small Claims (CVM)": "#FEF9C3",
  "Special Proceedings (SP)": "#D1FAE5",
  "Waiver Lists": "#FBCFE8",
};

const FALLBACK = [
  "#FDE2E4", "#E0F2FE", "#FEF3C7", "#DCFCE7", "#FEE2E2", "#EDE9FE",
  "#FFF1E6", "#CFFAFE", "#F3E8FF", "#FCE7F3", "#ECFCCB", "#E7E5E4",
  "#FEF9C3", "#D1FAE5", "#FBCFE8", "#DBEAFE",
];

let auto = {};
let idx = 0;

export function categoryTint(name) {
  if (MAP[name]) return MAP[name];
  if (!auto[name]) { auto[name] = FALLBACK[idx % FALLBACK.length]; idx += 1; }
  return auto[name];
}
